import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { AppleLoginRequest, AppleLoginResponse } from "@roman/shared/types/Apple";
import { isWebPlatform } from "@roman/shared/utils/platform";
import useSWRMutation from "swr/mutation";

export const useLoginWithApple = (useHandleError: (msg: string) => (err: RomanApiError) => void) => {
  const handleError = useHandleError("Appleでのログインに失敗しました");

  // Use mobile endpoint for mobile platforms
  const isWeb = isWebPlatform();
  const endpoint = isWeb ? "/oauth/apple/login" : "/oauth/apple/login/mobile";

  // Web uses httpOnly cookies, mobile uses request body tokens
  const fetcher = (url: string, args: { arg: AppleLoginRequest }) =>
    romanApi.post<AppleLoginResponse, AppleLoginRequest>(url, args.arg, {
      withCredentials: isWeb,
    });

  const { trigger } = useSWRMutation(endpoint, (url: string, args: { arg: AppleLoginRequest }) => fetcher(url, args), {
    onError: (error) => {
      handleError(error);
    },
  });
  return {
    trigger,
  };
};
